import { Component, OnInit } from '@angular/core';
import { CommonService } from '../../services/common.service';
import { GlobalService } from '../../services/global.service';
import { VendorClassificationDto, VendorClassification, VendorClassificationResponseDto, VendorClassificationView, VendorDeleteDto, VendorClassLookupRequest, VendorClassLookupResponseDto, SystemCompanyCodeMapping } from '../../models/vendorDetailsDtos'; 
import { ConstraintsModel, GridColumnHeader} from '../../models/grid-column-header';
import { vendorBooleanColumn, vendorInfoHeaders } from '../../common/staticGridColumnHeader';
import * as XLSX from 'xlsx';
import { DialogComponent, DialogData } from '../../shared/dialog/dialog.component';
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'app-vendor-info',
  templateUrl: './vendor-info.component.html',
  styleUrl: './vendor-info.component.scss'
})
export class VendorInfoComponent implements OnInit {
  selectedVendors: any[] = [];
  isDataAvailable: boolean= true;
  columns: GridColumnHeader[] =  vendorInfoHeaders;
  vendorClassificationsResponse!: VendorClassificationResponseDto;
  vendorClassification: VendorClassificationView[] = []; 
  selectedVendorClassification: VendorClassificationView[] = [];
  isTableLoading: boolean = true;
  sortField: string="";
  sortOrder: number = 1; // 1 for ascending, -1 for descending
  editingVendorInfoRows: { [index: number]: boolean } = {};
  totalRecords: number = 0;
  clonedRows: { [index: number]: VendorClassificationView } = {}; 
  isAnyRowBeingEdited: boolean = false;
  isNewRowBeingEdited: boolean = false;
  isDeleteMode: boolean = false;
  searchTextVendorERPId: string = "";
  searchCompanyCode: string = "";
  pageNumber: number = 0;
  rowsOptions = [ 
    { label: '25', value: 25 },
    { label: '50', value: 50 },
    { label: '75', value: 75 },
    { label: '100', value: 100 },
    { label: '200', value: 200 },
    { label: '300', value: 300 },
    { label: '500', value: 500 },
  ];
  rows: number = 25;
  dragSelecting = false;
  selectedIndexes: number[] = [];
  pagesToHoldData: number = 0;
  // Filtering
  filters: { [key: string]: any } = {};
  data: VendorClassificationView[] = []; 
  vendorBooleanColumn: string[] = vendorBooleanColumn; 
  filteredVendors: any[] = [];
  companyCodeValues: { companycode: string }[] = [];
  systemNameValues: { systemname: string }[] = [];
  vendorGroupValues: { vendorGroup: string }[] = [];
  validationTouched: boolean[] = [];
  systemCompanyCodeMapping: SystemCompanyCodeMapping[] = [];
  constructor(
    private readonly commonService: CommonService,
    private readonly globalVariable: GlobalService,
    private readonly dialog: MatDialog,
  ){ }

  ngOnInit(): void { 
    this.commonService.clearMessage();
    this.loadData();
    this.getCompanyCode();
    this.getSystemName();
    this.getVendorGroup();
    this.getSystemCompanyCodeMappings();
    this.setVendorGroupColumnType();
  }

  setVendorGroupColumnType() {
    this.columns = vendorInfoHeaders.map(col => {
      if (col.field === 'vendorGroup' && this.globalVariable.getSelectedSystemId === '6001') {
        return { ...col, type: 'string' };//Vendor Group Col field should be text field type for IBERIA
      }
      return col;
    });
  }

  onRowsChange(event: Event) {
    this.selectedIndexes = [];
    this.syncSelectedWorkItems();
    const target = event.target as HTMLSelectElement;
    const selectedValue = Number(target.value);
    this.rows = selectedValue === 0 ? this.vendorClassification.length : selectedValue;
  } 

  saveRow(index: number) {
    const row = this.vendorClassification[index];
    if (!this.validateRow(row)) {
      this.isAnyRowBeingEdited = true;
      this.validationTouched[index] = true;
      return;
    } 
    delete this.clonedRows[index];
    delete this.editingVendorInfoRows[index];
    this.validationTouched.splice(index, 1);
    this.saveAbbyyVendorDetails(row);
    this.isAnyRowBeingEdited = false;
  }

  saveAbbyyVendorDetails(vendorDetails: VendorClassificationView): void {
    let vendorClassification: VendorClassification;
    let vendorClassificationToRemove: VendorClassificationView;
    if(vendorDetails.isNew){
      vendorClassificationToRemove = vendorDetails;
    } 
    const { isNew, ...rest } = vendorDetails;
    vendorClassification  = { ...rest }; 
    let saveVendorClassification: VendorClassificationDto = {
      userGpid: this.globalVariable.getUserGPID,
      systemId: Number(this.globalVariable.getSelectedSystemId),
      abbyyPODetails: null,
      VendorDetails: [vendorClassification],
      isUIRequest: true,
      isVendorDetail : true
    }
    this.commonService.saveVendorClassifications(saveVendorClassification).subscribe({
      next: (response) => {
        this.commonService.showMessage("Saved Vendor Info.", 'success');
        if(this.isNewRowBeingEdited ){
          this.searchData();
          this.isNewRowBeingEdited = false;
        }
      },
      error: (error) => {
        if(vendorClassificationToRemove){
          this.vendorClassification = this.vendorClassification.filter(vi => vi.id != vendorClassificationToRemove.id &&
            vendorClassificationToRemove.isNew != vi.isNew);
        }
        this.commonService.showMessage(error.error.message, 'error');
      }
    });
  }

  validateRow(row: VendorClassificationView): boolean {
    const rowIndex = this.vendorClassification.findIndex(r => r === row);
    const original = this.clonedRows[rowIndex];
    const isvendorERPIDValid = (!!row.vendorERPID && this.selectedVendors[rowIndex]) || row.vendorERPID === original?.vendorERPID;
    // Vendor ERP Id must be selected from the list (selectedVendors)
    return isvendorERPIDValid && !!row.system &&
      this.isCompanyCodeSystemNameValid(row) ;
  }

  cancelSave(index?: any): void {
    const row = this.vendorClassification[index]; 
    if (row.isNew) {
      this.vendorClassification.splice(index, 1);
      // Update clone and editing status
      delete this.clonedRows[index];
      delete this.editingVendorInfoRows[index]; 
      this.isAnyRowBeingEdited = false;
      this.isNewRowBeingEdited = false;
      return;
    }
    if (this.clonedRows[index]) {
      this.vendorClassification[index] = { ...this.clonedRows[index] };
      delete this.clonedRows[index];
    } 
    delete this.editingVendorInfoRows[index]; 
    this.isAnyRowBeingEdited = false; 
    this.isNewRowBeingEdited = false;
  }
  
  editRow(index: number) {
    if (this.isAnyRowBeingEdited) return; 
    this.clonedRows[index] = { ...this.vendorClassification[index] };
    this.editingVendorInfoRows[index] = true;
    this.isAnyRowBeingEdited = true; 
    this.getVendorGroup(this.clonedRows[index].system);
  }

  addNewRow() {
    if (this.isAnyRowBeingEdited) return;
    this.isNewRowBeingEdited = true;
    let newRow: VendorClassificationView = {
      systemId: 0,
      id: 0,
      system: "",
      companyCode: "",
      vendorERPID: "",
      name: "",
      isCustomer: "",
      customerPOManualRouting: "",
      interCompany: "",
      daysDelay: "",
      autoRTV: "",
      isAutoposting: "",
      nonpoAllowed: "",
      taxcode: "",
      vendorGroup: "",
      isNew: true
    }; 
    this.vendorClassification.unshift(newRow);
    this.editingVendorInfoRows[0] = true;
    this.isAnyRowBeingEdited = true;
  }

  onCheckboxClick(index: number) {
    const alreadySelected = this.selectedIndexes.includes(index);
    if (alreadySelected) {
      this.selectedIndexes = this.selectedIndexes.filter(i => i !== index);
    } else {
      this.selectedIndexes.push(index);
    }
    this.syncSelectedWorkItems();
  }

  deleteSelectedRows() {
    if (this.isAnyRowBeingEdited) return;
    this.isAnyRowBeingEdited = true;

    if (!this.selectedVendorClassification?.length) {
      return;
    }
    const payload: VendorDeleteDto = {
      systemId: Number(this.globalVariable.getSelectedSystemId),
      userGpid: this.globalVariable.getUserGPID,
      id: this.selectedVendorClassification.map(item => item.id)
    };
    this.commonService.deleteVendorClassifications(payload).subscribe({
      next: (response) => {
        if (response) {
          this.isAnyRowBeingEdited = false;
          this.searchData()
          this.isDeleteMode = false;
          this.commonService.showMessage("Deleted Successfully.", 'success');
        }
      },
      error: (error) => {
        this.isAnyRowBeingEdited = false;
        this.commonService.showMessage(error.error.message, 'error');
      }
    });
  }

  toggleDeleteMode() {
    this.isDeleteMode = !this.isDeleteMode;
    if (!this.isDeleteMode) {
      this.selectedVendorClassification = [];
    }
  }


  onPageChange(event: any) {
    const currentPage = Math.ceil(event.first / event.rows) + 1;
    const rowsPerPage = event.rows;
    const totalPages = Math.ceil(this.totalRecords / rowsPerPage); 
    const isLastPage = (currentPage === totalPages - 1) || (currentPage === totalPages);
    if (isLastPage) {
      this.pagesToHoldData = event.first;
      this.vendorClassificationsResponse.currentPage = this.vendorClassificationsResponse.currentPage + 1;
      if (this.vendorClassificationsResponse.hasMoreItems) { 
        this.loadData();
      }
    }
  }

  searchData(): void {
    this.vendorClassification = [];
    this.data = [];
    this.totalRecords = 0;
    this.vendorClassificationsResponse.currentPage = 0;
    this.loadData();
  }

  loadData(): void {
    this.isTableLoading = true;
    let searchVName = this.searchTextVendorERPId != "" ? this.searchTextVendorERPId : "ALL";
    let searchCompanyCode = this.searchCompanyCode != "" ? this.searchCompanyCode : "ALL";
    let pageNo = 0;
    if(this.vendorClassificationsResponse?.currentPage){
      pageNo = this.vendorClassificationsResponse.currentPage;
    }
    this.commonService.getVendorClassifications(this.globalVariable.getUserGPID, this.globalVariable.getSelectedSystemId,
      searchVName, searchCompanyCode, pageNo).subscribe({
        next: (response) => {
          this.isDataAvailable = response.results.length > 0 ? true : false;
          this.vendorClassificationsResponse = response;
          this.totalRecords = (this.totalRecords == 0 && pageNo != 0) ? response.rowCount : this.totalRecords + response.rowCount;
          let dataWorkItems = response.results?.map((vendorClassification: VendorClassification) => ({
            ...vendorClassification,
            isNew: false
          }));
          this.vendorClassification = this.totalRecords == 0 ? dataWorkItems :
            [...this.vendorClassification, ...response.results?.map((vi: any) => ({
              ...vi,
              isNew: false
            }))];
            this.data = this.vendorClassification;
          this.generateFilters();
          this.customFilter();
          this.isTableLoading = false;
          setTimeout(() => {
            if (pageNo > 0) {
              this.pageNumber = this.pagesToHoldData;
            }
          }, 0);
        },
        error: (error) => {
          this.isDataAvailable = false;
          this.isTableLoading = true;
        }
      });
  }

  generateFilters() {
    this.columns.forEach(column => {
      if (column.type == 'date') {
        column.filterOptions = [
          { label: 'Past 7 days', value: '7' },
          { label: 'Past 14 days', value: '14' },
          { label: 'Past 1 month', value: '30' },
          { label: 'Past 2 months', value: '60' },
          { label: 'Past 3 months', value: '90' },
          { label: 'Past 6 months', value: '182' },
          { label: 'Last year', value: '365' },
          { label: 'All', value: 'All' }
        ];
        column.selectedValues = []; 
      } else {
        const values = new Set<string|boolean|number>(); 
        this.data.forEach(record => {
          if(record.isNew){return;}
          const propertyName: keyof VendorClassification = column.field as keyof VendorClassification;
          const value = record[propertyName];
          // Only add non-null, non-undefined values
          if (value != null) {
            values.add(value);
          }
        }); 
        if (vendorBooleanColumn.includes(column.field)) {
          column.filterOptions = Array.from(values).map(v => ({ label: v.toString() == '1' ? 'Yes' : 'No' , value: v.toString() }));
        } else {
          column.filterOptions = Array.from(values).map(v => ({ label: v.toString(), value: v.toString() }));
        }
        column.selectedValues = []; 
      }
    }); 
  }

  customClear(col: GridColumnHeader) {
    if(col.advancefilter.isAdvanceFilterUsed){
      this.clearCall(col);
    }
    this.filters[col.field] = [];
    this.customFilter(col.field);
  }
 
  isSelected( index: number): boolean {
    return this.selectedIndexes.includes(index);
  }

  onRowClick(event: MouseEvent, index: number): void {
    this.toggleRowSelection(index, event.ctrlKey || event.metaKey, event.shiftKey);
  }

  toggleRowSelection(index: number, ctrlKey: boolean, shiftKey: boolean): void {
    if (!ctrlKey && !shiftKey) { 
      this.selectedIndexes = [index];
    }
    else{
      const alreadySelected = this.selectedIndexes.includes(index);
      if (!alreadySelected) {
        this.selectedIndexes.push(index);
      }
      else {
        this.selectedIndexes = this.selectedIndexes.filter(i => i !== index);
      }
    } 
    this.syncSelectedWorkItems();
  }

  onMouseDown(event: MouseEvent, index: number) { 
    const ctrlKey = event.ctrlKey || event.metaKey;
    const shiftKey = event.shiftKey;
    if (event.button === 0 && !ctrlKey && !shiftKey) { 
      this.dragSelecting = true;
      this.selectedIndexes = [index];
      this.syncSelectedWorkItems();
      event.preventDefault();
    } 
  }

  onMouseOver(event: MouseEvent, index: number) {
    if (event.button === 0 && this.dragSelecting && !this.selectedIndexes.includes(index)) {
      this.selectedIndexes.push(index);
      this.syncSelectedWorkItems();
    }
  }

  onMouseUp() {
    if (this.dragSelecting) {
      this.dragSelecting = false; 
    } 
  }

  onRowKeydown(event: KeyboardEvent, index: number): void {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      this.toggleRowSelection(index, event.ctrlKey || event.metaKey, event.shiftKey);
    }
  }

  onRowFocus(_event: FocusEvent, _index: number): void {
  }

  syncSelectedWorkItems() {
    this.selectedVendorClassification = this.selectedIndexes
      .filter(i => i >= 0 && i < this.vendorClassification.length)
      .map(i => this.vendorClassification[i]); 
  }

  customFilter(value?: any){
    this.selectedIndexes=[];
    this.syncSelectedWorkItems();
    let filteredData = [...this.data];
    if (Object.keys(this.filters).length) {
      Object.keys(this.filters).forEach((field) => {
        const selectedValues = this.filters[field];
        if (!selectedValues || selectedValues.length === 0)
          return;

        const propertyName: keyof VendorClassification = field as keyof VendorClassification;
        filteredData = filteredData.filter((vendorData) => selectedValues.includes(vendorData[propertyName]));
      });
    }
    this.vendorClassification = filteredData; 
  }
   
  applyCall(col:GridColumnHeader, filterRef: any){
    col.advancefilter.isAdvanceFilterUsed = true;
    this.applyAdvancedFilter(col);
    filterRef.hide();
  }

  applyAdvancedFilter(col: GridColumnHeader) {
    const field = col.field;
    const filterMeta = col.advancefilter; 
    // Skip filtering if no constraints or filter not enabled
    if (!filterMeta?.isAdvanceFilterUsed || !filterMeta.constraints?.length) {
      return;
    } 
    const constraints = filterMeta.constraints;
    const lastConstraint = constraints[constraints.length - 1]; 
    const operator = !lastConstraint || lastConstraint.value === null || lastConstraint.value === ''
                      ? 'or' : filterMeta.operator || 'or';
    this.vendorClassification = this.vendorClassification.filter(row => {
        const rowValue = (row as any)[field]; 
        const results = constraints.map(constraint => {
          const filterValue = constraint.value;
          const matchMode = constraint.matchMode; 
          const stringValue = rowValue?.toString()?.toLowerCase?.();
          const filterString = filterValue?.toString()?.toLowerCase?.(); 
          switch (matchMode) { 
            case 'eq':
              return stringValue === filterString;
            case 'startswith':
              return stringValue?.startsWith(filterString);
            case 'contains':
              return stringValue?.includes(filterString);
            case 'doesnotcontain':
              return !stringValue?.includes(filterString);
            case 'endswith':
              return stringValue?.endsWith(filterString); 
            case 'gt':
              return new Date(rowValue) > new Date(filterValue);
            case 'gte':
              return new Date(rowValue) >= new Date(filterValue);
            case 'lt':
              return new Date(rowValue) < new Date(filterValue);
            case 'lte':
              return new Date(rowValue) <= new Date(filterValue); 
            case 'isnull':
              return rowValue == null || rowValue === '';
            case 'isnotnull':
              return rowValue != null && rowValue !== ''; 
            default:
              return true;
          }
        });
  
        // Combine with AND/OR operator
        return operator === 'or' ? results.some(r => r) : results.every(r => r);
    });
  }
 
  clearCall(col: GridColumnHeader, filterCallback?: any, filterRef?: any) {
    col.advancefilter.isAdvanceFilterUsed = false;
    col.advancefilter.constraints.forEach((c:ConstraintsModel) => {
      c.value = '';
    });
    this.vendorClassification = this.data;
    if(filterCallback && filterRef){
      filterCallback(null);filterRef.hide();
    }
  }

  onDateRuleChange(event: any, field: string, index: number) {
    const value = event ? event : event.target?.value;
    const col = this.columns.find(c => c.field === field);
    if (col) {
      col.advancefilter.constraints[index].value = value;
    }
  }

  onRuleChange(event: any, field: string, index: number) {
    const value = typeof event === 'string' ? event : event.target?.value;
    const col = this.columns.find(c => c.field === field);
    if (col) {
      col.advancefilter.constraints[index].value = value;
    }
  }

  onMatchModeChange(event: any, field: string, index: number) {
    const mode = typeof event === 'string' ? event : event.target?.value;
    const col = this.columns.find(c => c.field === field);
    if (col) {
      col.advancefilter.constraints[index].matchMode = mode;
    }
  }

  onOperatorChange(event: any, field: string) {
    const operator = typeof event === 'string' ? event : event.value;
    const col = this.columns.find(c => c.field === field);
    if (col) {
      col.advancefilter.operator = operator;
    }
  }

  searchVendors(event: any, field: string) {
    if (!event || typeof event.query !== 'string') {
      return;
    }

    const value = event.query;
    const payload: VendorClassLookupRequest = {
      userGpid: this.globalVariable.getUserGPID,
      systemId: Number(this.globalVariable.getSelectedSystemId),
      lookupFieldName: "VENDORERPID",
      lookupFieldValue: value,
    };

    this.commonService.getVendorClassAutoComboValueLookup<VendorClassLookupResponseDto>(payload).subscribe({
      next: (response: VendorClassLookupResponseDto[]) => {
        this.filteredVendors = response;
      },
      error: (err) => {
        this.commonService.showMessage('Error loading Vendor ERP Id values: ' + err.error.message, 'error');
      }
    });
  }

  onSystemNameChange(event: any, rowData: any) {
    const systemName = event?.value || event;
    rowData['vendorGroup'] = '';
    this.getVendorGroup(systemName);
  }

  getCompanyCode() {
    const payload: VendorClassLookupRequest = {
      userGpid: this.globalVariable.getUserGPID,
      systemId: Number(this.globalVariable.getSelectedSystemId),
      lookupFieldName: "COMPANYCODE",
      lookupFieldValue: "",
    };

    this.commonService.getVendorClassAutoComboValueLookup<{ companycode: string }>(payload).subscribe({
      next: (response: { companycode: string }[]) => {
        this.companyCodeValues = response;
      },
      error: (err) => {
        this.commonService.showMessage('Error loading Company Code values: ' + err.error.message, 'error');
      }
    });
  }

  getSystemName() {
    const payload: VendorClassLookupRequest = {
      userGpid: this.globalVariable.getUserGPID,
      systemId: Number(this.globalVariable.getSelectedSystemId),
      lookupFieldName: "SYSTEM_NAME",
      lookupFieldValue: "",
    };

    this.commonService.getVendorClassAutoComboValueLookup<{ systemname: string }>(payload).subscribe({
      next: (response: { systemname: string }[]) => {
        this.systemNameValues = response;
      },
      error: (err) => {
        this.commonService.showMessage('Error loading Company Code values: ' + err.error.message, 'error');
      }
    });
  }

  getVendorGroup(systemName?: string) {
    const payload: VendorClassLookupRequest = {
      userGpid: this.globalVariable.getUserGPID,
      systemId: Number(this.globalVariable.getSelectedSystemId),
      lookupFieldName: "VENDORGROUP",
      lookupFieldValue: "",
      systemName: systemName
    };

    this.commonService.getVendorClassAutoComboValueLookup<{ vendorGroup: string }>(payload).subscribe({
      next: (response: { vendorGroup: string }[]) => {
        this.vendorGroupValues = response;
      },
      error: (err) => {
        this.commonService.showMessage('Error loading Vendor Group values: ' + err.error.message, 'error');
      }
    });
  }

  getSystemCompanyCodeMappings() {
    const payload: VendorClassLookupRequest = {
      userGpid: this.globalVariable.getUserGPID,
      systemId: Number(this.globalVariable.getSelectedSystemId),
      lookupFieldName: "SYSCOMPANYCODE",
      lookupFieldValue: "",
    };

    this.commonService.getVendorClassAutoComboValueLookup<{ companycode: string; systemname: string }>(payload).subscribe({
      next: (response: { companycode: string; systemname: string }[]) => {
        this.systemCompanyCodeMapping = response;
      },
      error: (err) => {
        this.commonService.showMessage('Error loading Company Code values: ' + err.error.message, 'error');
      }
    });
  }

  isCompanyCodeSystemNameValid(rowData: any): boolean {
    if (!rowData.companyCode || !rowData.system) return true;

    return this.systemCompanyCodeMapping.some(
      (map) =>
        map.companycode === rowData.companyCode &&
        map.systemname === rowData.system
    );
  }

  onVendorSelect(event: any, rowData: any, rowIndex: number) {
    const selected = event.value as VendorClassLookupResponseDto;
    this.selectedVendors[rowIndex] = selected;
    rowData['vendorERPID'] = selected.vendorERPID.trim();
    rowData['name'] = selected.vendorname.trim();
  }

  onVendorInputChange(value: string, rowIndex: number) {
    if (!value || !this.selectedVendors[rowIndex] || this.selectedVendors[rowIndex].vendorerpid !== value) {
      this.selectedVendors[rowIndex] = '';
    }
  }
  

  exportToExcel() {
    try {

      let searchVName = this.searchTextVendorERPId != "" ? this.searchTextVendorERPId : "ALL";
      let searchCompanyCode = this.searchCompanyCode != "" ? this.searchCompanyCode : "ALL";
      let pageNo = 0;
      let pageSize = 100000;
	
	    this.commonService.getVendorClassifications(this.globalVariable.getUserGPID, this.globalVariable.getSelectedSystemId, searchVName, searchCompanyCode, pageNo, pageSize).subscribe({
        next: (response) => {

          const dialogData: DialogData = {
            title: 'EXPORT TO EXCEL',
            message: "Data is getting downloaded...",
            showFinishButton: false,
            showOkButton: false,
            showCancelButton: true,
            showLoading: true,
          };

          const dialogRef = this.dialog.open(DialogComponent, {
            width: '600px',
            height: '160px',
            data: dialogData,
          });

          const toYesNo = (value: string | number | null | undefined) => {
            if (value == 0 || value == null || value === "") return "No";
            if (value == 1) return "Yes";
            return value;
          };

          const cleanedData = response.results.map(item => ({
            'System': item.system,
            'Company Code': item.companyCode,
            'Vendor ERP ID': item.vendorERPID,
            'Vendor Name': item.name,
            'Customer': toYesNo(item.isCustomer),
            'Customer PO Manual Routing': toYesNo(item.customerPOManualRouting),
            'Inter Company': toYesNo(item.interCompany),
            'Days Delay': item.daysDelay,
            'Auto RTV': toYesNo(item.autoRTV),
            'Verification Required': toYesNo(item.isAutoposting),
            'Non PO Allowed': toYesNo(item.nonpoAllowed),
            'Tax Code': item.taxcode,
            'Vendor Group': item.vendorGroup
          }));

          // Convert selected data to worksheet
          const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(cleanedData);

          // Auto-adjust column widths based on headers and data
          ws['!cols'] = Object.keys(cleanedData[0] || {}).map(key => {
            const maxLength = Math.max(
              key.length,
              ...cleanedData.map(row => String(row[key as keyof typeof row] ?? '').length)
            );

            return { wch: maxLength + 2 }; // Add padding
          });

          // Create a new workbook and append the worksheet
          const wb: XLSX.WorkBook = XLSX.utils.book_new();
          XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

          // Generate Excel file
          XLSX.writeFile(wb, 'Vendor_Classification_Data.xlsx');
          this.commonService.showMessage('File downloaded successfully.', 'success');
          dialogRef.close();
        },
        error: (error) => {
          this.commonService.showMessage('Error while downloading excel file.', 'error');
        }
      });
     
    } catch (error) {
      this.commonService.showMessage('Error while downloading excel file.', 'error');
    }
  }
}
